import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import { getProduct } from '@/src/request/product/product';
import { getI18nFromGeneral } from '@/src/tools/tools';
import React, { ReactNode, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Form, Modal, Skeleton } from 'src/components/Antd';
import { getProduct as getSubmitProduct } from 'src/pages/ProductEditor/tools/Submit/ProductSubmit';
import {
  activateProductThunk as activateProduct,
  archiveProductThunk as archiveProduct,
  draftProductThunk as draftProduct,
  submitProductThunk as submitProduct,
} from 'src/pages/ProductEditor/tools/commonRequests';
import Attributes from './Attribute';
import CustomInfo from './CustomInformation/SimpleProductCustomInformationSection';
import Dimensions from './Dimensions/SimpleProductDimensionsSection';
import Image from './Images/Images';
import Pricing from './Pricing/SimpleProductPricingSection';
import ProductInfo from './ProductInfo/SimpleProductProductInfoSection';
import Stock from './Stock/SimpleProductStockSection';
import Tags from './Tags/SimpleProductTagsSection';
import { IParams } from './type';
// import { Form } from 'antd';

import { emptyData, fetchProduct, onHasModifiedChange } from './Slice';

import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';

import { NEW } from '@/src/tools/constant';
import { EnumReducers } from 'src/store/constants';
import { EnumProductType, EnumStatus } from 'src/types/common/product';
import { getStatusValue } from '../tools/selectors';

import { onDelete } from '../tools/commonModal/delete';

import { cloneDeep } from 'lodash';
import { onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { onDuplicates } from '../tools/commonModal/duplicate';
import { getProductName } from '../tools/getPageName';
//import { useI18n } from 'src/hooks/useRouterChange';

// import {
//   // productSubmit,
//   productDraft,
//   productActive,
//   productArchive,
// } from '../tools/Submit/ProductSubmit';
import { switchProductHooks } from '../tools/hooks/customHooks';
import Available from './SalesChannelAvailability';
const formName = 'SimpleProduct';

import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

const SimpleProductEditor = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const i18n = useI18n();
  const canEdit = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });

  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.delete_product,
      }),
    ],
  });

  const [otherCodeForm] = Form.useForm();
  const [form] = Form.useForm();
  // const [discardModal, setDiscardModal] = React.useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
  const [avaAtt, setAvaAtt] = React.useState([]);
  //const [warehouses, setWarehouses] = React.useState<string[]>([]);
  const handleOnAvaAttOptionsChange = (uuid, option) => {
    const _avaAtt = avaAtt.map((i) => {
      const { uuid: sUid, options } = i;
      if (uuid === sUid) {
        const _o = [...(options || []), option];
        return { ...i, options: _o };
      }
      return i;
    });
    setAvaAtt(_avaAtt);
  };
  const dispatch = useDispatch();
  const [modalContent, setModalContent] = useState<ReactNode>('');
  const params: IParams = useParams();
  const { hasModified, loaded, status, uuid } = useSelector(
    getStatusValue(EnumReducers.simpleProduct),
  );

  let { uuid: urlUuid }: any = params;
  const pageTitle = getProductName(
    hasModified,
    loaded,
    urlUuid,
    EnumReducers.simpleProduct,
    EnumProductType.Simple,
    { getI18n },
  );

  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/productsList',
      name: getI18n('general.allProducts'),
    },
    {
      url: '',
      name: pageTitle,
    },
  ];

  React.useEffect(() => {
    if (urlUuid === NEW) {
      urlUuid = '';
    }
    getProduct(urlUuid)
      .then((res: any) => {
        const { product } = res || {};
        const {
          availAttributes,
          attributes,
          taxRules,
          taxRulesEnabled,
          warehouseStocks,
          oversellQuotaEnabled,
          salesChannelStockEnabled,
          stockAvailable,
        } = product || {};

        // const warehouseStocks = (_warehouseStocks || []).reduce((pre, i) => {
        //   const { warehouseUuid } = i;
        //   return { ...pre, [warehouseUuid]: i };
        // }, {});
        //console.log(_warehouseStocks);
        // const allWarehouses = (_warehouseStocks || []).map(
        //   (i) => i.warehouseUuid,
        // );
        // setWarehouses(allWarehouses);
        //console.log(_warehouseStocks);
        setAvaAtt(availAttributes || []);
        // console.log(warehouseStocks);
        form.setFieldsValue({
          attributes,
          taxRules,
          taxRulesEnabled,
          warehouseStocks,
          oversellQuotaEnabled,
          salesChannelStockEnabled,
          stockAvailable,
          //test: 123,
        });
        dispatch(fetchProduct(res));
      })
      .catch(() => {
        dispatch(fetchProduct(null));
      });

    // dispatch(fetchProduct(urlUuid));

    return () => {
      dispatch(emptyData());
    };
  }, []);
  // useAfterDidMountEffect(() => {
  //   history.push(`/product/simpleProduct/${uuid}`);
  // }, [uuid]);
  switchProductHooks(EnumProductType.Simple);
  // const [okText, setOkText] = useState<string>('');
  const onModalCancel = () => {
    setShowModal(false);
  };

  const handleOnError = (error) => {
    //console.log('error', error);
    onFinishFailed(formName, error);
    return false;
  };

  //const draftFields = [];
  const publishFields = avaAtt.map((i) => {
    const { uuid } = i;
    return ['attributes', uuid];
  });

  const _getValue = () => {
    const value = form.getFieldsValue();
    //  const { warehouseStocks } = value;

    return value;
  };
  const _getProduct = (s, productType) => {
    const warehouses = form.getFieldValue('warehouseStocks') || [];

    const warehouseKeys = warehouses.reduce((pre, now, index) => {
      return [
        ...pre,
        ['warehouseStocks', index, 'oversellingQuota'],
        ['warehouseStocks', index, 'salesChannelItems'],
      ];
    }, []);

    const rules = ['taxRules', ...warehouseKeys];
    const _status = s || status;
    const fields = _status === EnumStatus.Active ? rules : [];
    // const warehouseError = form.getFieldError('warehouseStocks');

    const attError = form.getFieldsError(publishFields);
    const errorItem = attError.find((i) => i.errors.length > 0);
    const hasError = !!errorItem;
    // console.log('hasError', hasError);
    if (hasError) {
      // console.log('errorItem', errorItem);
      const { name = [] } = errorItem;
      const pre = formName + '_';
      const suf = name.join('_');
      const id = pre + suf;
      timeoutScroll(id);
      return;
    }
    //console.log('fields', fields);
    return form
      .validateFields(fields)
      .then(() => {
        //console.log('没错');
        const v = _getValue();
        const reduxProduct = getSubmitProduct(s, productType);
        const p = { ...reduxProduct, ...v };
        //console.log('p', p);
        return p;
      })
      .catch((e) => {
        console.log('err', e);
        handleOnError(e);
        return null;
      });

    //console.log('p', p);
    // return p;
  };

  const onSubmit = (params?) => {
    const productType = EnumProductType.Simple;
    // productSubmit({ ...(params || {}), productType: EnumProductType.Simple });
    const { cb, hideMsg, status } = params || {};
    const product = _getProduct(status, productType);

    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(submitProduct({ prod: product, hideMsg }));
            if (cb) cb(product);
          }
        }
      });
    }
  };
  const setDraft = () => {
    const product = _getProduct(EnumStatus.Draft, EnumProductType.Simple);
    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(draftProduct(product));
          }
        }
      });
    }

    // productDraft({ productType: EnumProductType.Simple });
  };
  const setActive = () => {
    const product = _getProduct(EnumStatus.Active, EnumProductType.Simple);

    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(activateProduct(product));
          }
        }
      });
    }
  };
  const setArchived = () => {
    const product = _getProduct(EnumStatus.Archived, EnumProductType.Simple);
    if (product) {
      product.then((product) => {
        if (product) {
          const { dataValid } = product;
          if (dataValid) {
            dispatch(archiveProduct(product));
          }
        }
      });
    }
  };

  const history = useHistory();

  const _delete = () => {
    onDelete(uuid, setShowModal, setModalContent, setModalTitle);
  };

  const _duplicate = () => {
    const processData = (prod) => {
      const { attributes, warehouseStocks } = prod;
      const _warehouseStocks = (warehouseStocks || []).map((i) => {
        const { salesChannelItems } = i || {};
        const _salesChannelItems = (salesChannelItems || []).map((item) => {
          return {
            ...(item || {}),
            availableQuantity: 0,
          };
        });
        return {
          ...(i || {}),
          oversellingQuota: 0,
          totalAvailableForSale: 0,
          unassignedAvailableForSale: 0,
          warehouseStock: 0,
          salesChannelItems: _salesChannelItems,
        };
      });
      const isUnique = avaAtt.filter((i) => i.unique).map((i) => i.uuid);
      const _attributes = cloneDeep(attributes);
      isUnique.forEach((i) => {
        _attributes[i] = null;
      });

      form.setFieldsValue({
        taxRules: [],
        attributes: _attributes,
        warehouseStocks: _warehouseStocks,
      });
      prod.sku = null;
      prod.warehouseStocks = _warehouseStocks;

      return prod;
    };
    onDuplicates(
      onSubmit,
      setShowModal,
      setModalContent,
      setModalTitle,
      status,
      processData,
    );
  };

  const goBackToList = () => {
    history.push({
      pathname: '/productsList',
    });
  };
  const topLeft = (
    <TopLeft goBack={goBackToList} breadcrumbData={breadcrumbData} />
  );

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        onSubmit();
      }}
      onSaveDisable={canEdit ? !hasModified : true}
      displayDuplicateGroup={!!uuid && status !== EnumStatus.Archived}
      onDelete={canDelete ? _delete : null}
      onCopy={canEdit ? _duplicate : null}
      status={status}
    />
  );
  const Child = [
    {
      child: (
        <ProductInfo
          pageTitle={pageTitle}
          setModalContent={setModalContent}
          setModalTitle={setModalTitle}
          otherCodeForm={otherCodeForm}
          setShowModal={setShowModal}
          // setOkText={setOkText}
          setDraft={setDraft}
          setActive={setActive}
          setArchived={setArchived}
          disabled={!canEdit}
        />
      ),
    },
    {
      child: (
        <Attributes
          disabled={!canEdit}
          avaAtt={avaAtt}
          onAttOptionsChange={handleOnAvaAttOptionsChange}
          productUuid={urlUuid === NEW ? null : urlUuid}
        />
      ),
    },
    {
      child: <Tags disabled={!canEdit} />,
    },
    { child: <Image disabled={!canEdit} /> },

    {
      child: (
        <Stock
          disabled={!canEdit}
          form={form}
          uuid={urlUuid}
          //warehouses={warehouses}
          title={getI18n('allProducts.addproductset.stock_title')}
          secondTitle={getI18n(
            'allProducts.addproductset.general_stock_secondTitle',
          )}
        />
      ),
    },
    {
      child: (
        <Pricing
          productUuid={urlUuid === NEW ? null : urlUuid}
          disabled={!canEdit}
        />
      ),
    },

    {
      child: <Dimensions disabled={!canEdit} />,
    },

    {
      child: <CustomInfo disabled={!canEdit} />,
    },
    { child: <Available disabled={!canEdit} /> },
  ];

  return (
    <React.Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.leave')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.leave_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />

      <Form
        form={form}
        name={formName}
        onValuesChange={(_, allValues) => {
          dispatch(onHasModifiedChange());
        }}>
        <Skeleton loading={!loaded} active>
          <Layout elements={Child} topLeft={topLeft} topRight={topRight} />
        </Skeleton>
      </Form>
      <Modal
        width={600}
        visible={showModal}
        title={modalTitle}
        onCancel={onModalCancel}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>
    </React.Fragment>
  );
};

export default SimpleProductEditor;
